import { useTranslation } from 'react-i18next';
import SecSeperator from './ui/SecSeperator';
import { IWhyAuto24, WHY_AUTO24_ARR, WHY_AUTO24_SELLPAGE_ARR } from '../utils/Stats';

export enum IN_PAGE {
    SELLPAGE="SELLPAGE"
}

interface IChooseAuto24Props {
    page?: IN_PAGE;
}

const ChooseAuto24 = (props: IChooseAuto24Props) => {
    const { page } = props;
    const { t, i18n } = useTranslation();

    function getWhyAuto24ArrByPage () {
        switch(page) {
            case IN_PAGE.SELLPAGE:
                return WHY_AUTO24_SELLPAGE_ARR;
            default:
                return WHY_AUTO24_ARR;
        }
    }

    return (
        <div className="chooseAuto24">
            <div className="chooseAuto24-container">
                <SecSeperator />
                <h2 className="title" dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>{t(`whyChooseAuto`)}</h2>
                <div className="chooseAuto24-content">
                    { getWhyAuto24ArrByPage().map((item: IWhyAuto24, index: number) =>
                    <div className='chooseAuto24-content-item' key={index}>
                        <div className='chooseAuto24-content-item-imageContainer'>
                            <img src={item.imagesrc} alt={t(item.alt)} loading='lazy' />
                        </div>
                        <p className='chooseAuto24-content-item-title' dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>{t(`${item.title}`)}</p>
                        <p className='chooseAuto24-content-item-subtitle' dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>{t(item.descs)}</p>
                    </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ChooseAuto24;
